import { gEnums } from "../../enums/globalEnums";

export const ammendViewSettingsSortPositions = (menuType, viewItems, vit, sortedGroups, sortedDataItems) => {

  if (sortedDataItems) {
    switch (menuType) {
      case gEnums.menuTypes.viewItem:
        _.forEach(sortedDataItems, (sid, sdiIndex) => {
          if (sid.key && viewItems[sid.key]) {
            viewItems[sid.key].position = sdiIndex
          }
        })
        break;
      case gEnums.menuTypes.propItem:
        const prs = viewItems[vit].props
        _.forEach(sortedDataItems, (sid, sdiIndex) => {
          if (sid.key && prs[sid.key]) {
            prs[sid.key].position = sdiIndex
          }
        })
        break;
    }
  }

  if (sortedGroups) {
    console.log('sortedGroups', sortedGroups)
    // when items are sorted.
    switch (menuType) {

      case gEnums.menuTypes.viewItem:
        if (sortedGroups['viewItems']) {
          const items = sortedGroups['viewItems']
          Object.keys(items).forEach(key => {
            viewItems[key].position = items[key].position
          })
        }
        break;

      case gEnums.menuTypes.propItem:
        if (vit) {
          const prs = viewItems[vit].props
          Object.keys(sortedGroups).forEach(key => {
            const sg = sortedGroups[key]
            Object.keys(sg).forEach(key2 => {
              const pr = sg[key2]
              prs[pr.key].position = pr.position
              prs[pr.key].propSection = pr.propSection
            })
          })
        }
        break;

      case gEnums.menuTypes.propSections:
        if (vit && sortedGroups['propSections']) {
          const ps = sortedGroups['propSections']
          Object.keys(ps).forEach(key => {
            viewItems[vit].propSections[key].position = ps[key].position
          })
        }
        break;

      default:
      // nothing
    }
  }


}

export const sortViewSettingItems = (sortedItems, sortedPropItems, sortedPropSections, viewItems, propSections, sortVit) => {
  if (sortedItems) {
    Object.keys(sortedItems).forEach(key => {
      viewItems[key].position = sortedItems[key].position
    })
  } else if (sortedPropItems) {
    const prs = viewItems[sortVit].props
    Object.keys(sortedPropItems).forEach(key => {
      prs[key].position = sortedPropItems[key].position
      if (sortedPropItems[key].propSection) { prs[key].propSection = sortedPropItems[key].propSection }
    })
    if (propSections) { viewItems[sortVit].propSections = propSections }
  } else if (sortedPropSections) {
    const _propSections = viewItems[sortVit].propSections
    Object.keys(sortedPropSections).forEach(key => {
      _propSections[key].position = sortedPropSections[key].position
    })
  }
}